<template>
    <div id="ResearchBriefs" class="page" >
        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="briefs"></appHeader>
        <div class="main">
            <div class="main_inner">
                <section class="main_section">
                    <div class="section_content">
                        <h2 class="text_subtitle">More</h2>
                        <h1 class="title_page text_title2">
                            Research briefs
                        </h1>
                        <p class="text_p" style="margin-top: 24px;">
                            Here you will find the EUTO's latest research papers and briefs on the topics covered by the Atlas.
                        </p>
                    </div>
                </section>

                <section class="main_section section_brief" v-for="(briefObj, briefIndex) in DBBriefs">
                    <div class="section_content">
                        <a class="content_title" :href="briefObj.link" target="_blank">{{briefObj.title}}</a>
                        <div class="content_date">Published {{briefObj.date}}</div>
                        <div class="content_details">
                            <a class="content_image" :href="briefObj.link" target="_blank">
                                <img v-if="briefObj.image == ''" src='/images/visual-brief.png' />
                                <img v-else :src="briefObj.image" />
                            </a>
                            <div class="content_desc" v-if="briefObj.expanded">{{briefObj.description}}</div>
                            <div class="content_desc" v-else>{{ truncate(briefObj.description) }}</div>
                        </div>
                        <div class="more_actionbar" v-if="briefObj.description.length > briefTextLimit">
                            <div class="actionbar_bt" @click="briefObj.expanded = !briefObj.expanded">{{ briefObj.expanded ? 'Collapse' : 'Read More' }}</div>
                        </div>
                    </div>
                </section>
            </div> 
        </div>
        <appFooter></appFooter>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal
        },

        data: function () {
            return {
                isDataLoaded: false,
                DBCountries: [],
                DBBriefs: [],
                briefTextLimit: 600,
                loadingMethod: "csv",
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this; 
            //if(location.host == "staging-eu-tax-observatory.wedodata.dev") this.loadingMethod = "gsheet";

            if(this.loadingMethod == "csv"){
                this.loadStaticCSVData();
            } else {
                this.loadStaticSpreadsheetData();
            }
        },

        methods: {
            loadStaticSpreadsheetData: function (){
                var self = this;
                UTILS.loadStaticSpreadsheetData().then(function (callbackStatic){
                    console.log("callbackStatic", callbackStatic);
                    var tmpDBBriefs = [];
                    _.each(callbackStatic[1], function (objBrief){
                        objBrief.expanded = false;
                        tmpDBBriefs.push(objBrief);
                    })
                    self.DBBriefs = JSON.parse(JSON.stringify(tmpDBBriefs));
                    self.loadCountriesMetadata();
                })
            },

            loadStaticCSVData: function (){
                var self = this;
                console.log("loadStaticCSVData")
                UTILS.loadStaticCSVData().then(function (callbackStatic){
                    var tmpDBBriefs = [];
                    _.each(callbackStatic[1], function (objBrief){
                        objBrief.expanded = false;
                        tmpDBBriefs.push(objBrief);
                    })
                    self.DBBriefs = JSON.parse(JSON.stringify(tmpDBBriefs));
                    self.loadCountriesCSVMetadata();
                })
            },

            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData().then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            loadCountriesCSVMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            truncate(text) {
                if(text.length > this.briefTextLimit) return `${text.substring(0, this.briefTextLimit)}...`;
                return text;
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },
        },

        watch: {

        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #ResearchBriefs .main{
        background: #fff;
        .main_section{
             &.section_brief{
                padding: 50px 0 60px;
                background: linear-gradient(180deg, #EEF1F6 0%, rgba(238, 241, 246, 0.00) 100%);
                .content_title{
                    font-size: 32px;
                    text-decoration: none;
                    cursor: pointer;
                    color: $colorBlue;
                    letter-spacing: 3.2px;
                    font-weight: 400;
                    padding-top: 10px;
                    position: relative;
                    display: block;
                    &:before{
                        content:"";
                        position: absolute;
                        left: 0px;
                        bottom: 100%;
                        width: 100%;
                        margin-bottom: 6px;
                        background: $colorBlue;
                        height: 4px;
                    }
                }
                .content_date{
                    font-size: 12px;
                    color: $colorBlue;
                    letter-spacing: 0.6px;
                    margin-top: 10px;
                }
                .content_details{
                    margin-top: 10px;
                    .content_image{
                        display: inline-block;
                        vertical-align: top;
                        width: 232px;
                        img{
                            position: relative;
                            top: 5px;
                            width: 100%;
                        }
                    }
                    .content_desc{
                        display: inline-block;
                        vertical-align: top;
                        width: 670px;
                        font-size: 18px;
                        line-height: 170%;
                        color: $colorBlack;
                        margin-left: 16px;
                    }
                }
            }
        }
    }

   
</style>



// WEBPACK FOOTER //
// pages/research-briefs/index.vue